import { render, staticRenderFns } from "./Newsdetail.vue?vue&type=template&id=7f7c3d47"
import script from "./Newsdetail.vue?vue&type=script&lang=js"
export * from "./Newsdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports